import { render, staticRenderFns } from "./SectionGreeting.vue?vue&type=template&id=85d2fa0c&scoped=true"
import script from "./SectionGreeting.vue?vue&type=script&lang=js"
export * from "./SectionGreeting.vue?vue&type=script&lang=js"
import style0 from "./SectionGreeting.vue?vue&type=style&index=0&id=85d2fa0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d2fa0c",
  null
  
)

export default component.exports